import * as constants from '../../../utils/constants';
import ModalIcon from '../../../assets/image_modal_search_limit.svg';
import ModalErrorIcon from '../../../assets/ride_fi_not_found_light.svg';
import { getContentModal } from '../../../utils/getContentModal';

const MaintenanceModalInfo = {
  icon: ModalErrorIcon,
  title: '¡Queremos seguir mejorando! ',
  text: (
    <div className='modal-maintenance'>
      <span>Estamos realizando mantenimiento a nuestra plataforma digital. Durante ese tiempo, no estará disponible.</span>
      <br/>
      <br/>
      <span>Te pedimos que envíes tu solicitud de siniestros al siguiente correo: <a className='modal-maintenance__mail' href="mailto:siniestrosprotecciondetarjeta@bbva.com"><strong>siniestrosprotecciondetarjeta@bbva.com</strong></a></span>
      <br/>
      <br/>
      <span>Para conocer los documentos que necesitas adjuntar, puedes:</span>
      <br/>
      <br/>
      <ul className='modal-maintenance__list'>
        <li>Visitar nuestra web <a href='https://bbva.com.pe' target="_blank"><strong>bbva.com.pe</strong></a>, ingresando a la sección Atención de Siniestros o Fraude</li>
        <li>Comunicarte al <strong>(01) 595-9000, opción 3</strong></li>
      </ul>
      <br/>      
      <span>Horario de atención:</span>
      <br/>
      <span>Lunes a sábado, de 8:00 a.m. a 8:00 p.m.</span>      
    </div>
  ),
  btnText: 'Entendido',
};

const errorModalInfo = getContentModal({
  icon: ModalIcon,
  title: 'No hemos encontrado tu seguro de Protección de Tarjetas',
  text: (
    <div style={{textAlign: 'start'}}>
      Si adquiriste tu seguro hace <strong>3 días o menos</strong>, te pedimos que envíes tu solicitud de atención de siniestros al siguiente correo:  <a href='mailto:siniestrosprotecciondetarjeta@bbva.com'><strong>siniestrosprotecciondetarjeta@bbva.com</strong></a>
      <br/><br/>Para conocer los documentos que necesitas adjuntar, puedes:
      <br/>Visitar nuestra web <a target='_blank' href='https://www.bbva.pe/personas/productos/seguros/bienes/proteccion-de-tarjetas.html'><strong>bbva.com.pe</strong></a>, ingresando a la sección <strong>Atención de Siniestros o Fraude</strong> o comunicarte con nosotros al  <strong>(01) 595-9000</strong>, opción 3
      <br/>Horario de atención:
      <br/>Lunes a sábado, de 8:00 a.m. a 8:00 p.m.      
    </div>
  ),
  btnText: 'Entendido',
});

const errorAlreadyRegisteredInfo = getContentModal({
  icon: ModalIcon,
  title: 'Ya has registrado una solicitud de atención',
  text: (
    <div>
      <p>
        Si necesitas reportar otra cobertura que no incluiste, escribe al
        correo:
      </p>
      <p>
        siniestrosprotecciondetarjeta@bbva.com con el siguiente asunto: Nombres
        completos, DNI y fecha de siniestro. Detalla en el correo la cobertura
        solicitada y adjunta tus movimientos bancarios.
      </p>
    </div>
  ),
  btnText: 'Entendido',
});

const errorAlreadyRegisteredLetter = getContentModal({
  icon: null,
  title: '',
  text: (
    <div>
      <p>
        Ya completaste todos los documentos requeridos. El registro de tu siniestro está siendo revisado.
      </p>
    </div>
  ),
  btnText: 'Entendido',
});

const errorOtherUserRegistered = getContentModal({
  icon: null,
  title: '',
  text: (
    <div>
      <p>
        El número de registro no está asociado al número de documento o a la fecha del siniestro. Por favor, revisa e intenta de nuevo
      </p>
    </div>
  ),
  btnText: 'Entendido',
});

const errorSysDate = getContentModal({
  icon: null,
  title: '',
  text: (
    <div>
      <p>
        La fecha ingresada no cuadra con la fecha del sistema.
      </p>
    </div>
  ),
  btnText: 'Entendido',
});

const errorCaptcha = getContentModal({
  icon: null,
  title: '',
  text: (
    <>
      <p>
        Uy, ocurrió un error, por favor inténtalo nuevamente.
      </p>
      <b/>
      <p>
        También puedes descargar de la web <a target='_blank' href='https://bbva.com.pe'><strong>bbva.com.pe</strong></a> el formulario de atención de siniestros y enviarlo al correo de atención <a href='mailto:siniestrosprotecciondetarjeta@bbva.com'><strong>siniestrosprotecciondetarjeta@bbva.com</strong></a>
      </p>
    </>
  ),
  btnText: 'Entendido',
});

const errorSinisterNotExits = getContentModal({
  icon: null,
  title: '',
  text: (
    <div>
      <p>
        El número de registro que ingresaste no corresponde a una solicitud. Por favor, revisa e intenta de nuevo.
      </p>
    </div>
  ),
  btnText: 'Entendido',
});

const errorModStateClient = getContentModal({
  icon: ModalIcon,
  title: 'La plataforma está en  mantenimiento.',
  text: (
    <div>
      <p>
        Por el momento no podrás registrar tu siniestro en el formulario digital, por favor escribe a 
        <strong> siniestrosprotecciondetarjeta@bbva.com</strong> incluyendo los documentos requeridos.
        <br/> Ver relación de documentos <a href={constants.LINK_RIMAC_PROTECCION_TARJETA} target='_blank' style={{color: '#F60606', fontWeight: 'bold'}}>aquí</a>
      </p>
    </div>
  ),
  btnText: 'Entendido',
});

const errorModStateAdvisor = getContentModal({
  icon: ModalIcon,
  title: 'La plataforma está en  mantenimiento.',
  text: (
    <div>
      <p>
        Por el momento no podrás registrar tu siniestro en el formulario digital, por favor escribe a 
        <strong> siniestrosprotecciondetarjeta@bbva.com</strong> incluyendo los documentos requeridos.
        <br/> Ver relación de documentos <a href={constants.LINK_RIMAC_PROTECCION_TARJETA} target='_blank' style={{color: '#F60606', fontWeight: 'bold'}}>aquí</a>
      </p>
    </div>
  ),
  btnText: 'Entendido',
});

export {
  errorModalInfo,
  errorAlreadyRegisteredInfo,
  errorAlreadyRegisteredLetter,
  errorOtherUserRegistered,
  errorSysDate,
  errorCaptcha,
  errorSinisterNotExits,
  errorModStateClient,
  errorModStateAdvisor,
  MaintenanceModalInfo
};
